import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import Tooltip from '../../Tooltip/Tooltip';

const dotColorClasses = {
  draft: 'bg-blue-100 dark:bg-blue-600',
  archived: 'bg-slate-200',
  review: 'bg-orange-200',
  public: 'bg-lime-100 dark:bg-lime-600',
  modified: 'bg-orange-100 dark:bg-orange-600',
  saved: 'bg-lime-200',
  scheduled: 'bg-indigo-200 dark:bg-indigo-500',
};

const textColorClasses = {
  draft: 'text-blue-800 dark:text-blue-300',
  public: 'text-lime-800 dark:text-lime-200',
  modified: 'text-orange-800 dark:text-orange-300',
  saved: 'text-lime-700 dark:text-lime-500',
  archived: 'text-slate-600 dark:text-slate-400',
  scheduled: 'text-indigo-700 dark:text-indigo-300',
};

interface TopbarStatusProps {
  /**
   * Object status
   */
  status?: keyof typeof textColorClasses;
  /**
   * Object status label
   */
  label?: ReactNode;
  /**
   * Tooltip text
   */
  tooltip?: string;
  /**
   * Component test id
   */
  testId?: string;
}

const TopbarStatus = ({
  status = 'draft',
  label,
  testId,
  tooltip,
}: TopbarStatusProps) => (
  <Tooltip
    tooltip={tooltip}
    tooltipPlacement={'bottomCenter'}
    phoneTooltipPlacement={'topLeft'}
    {...getTestProps(testId, `topbar-tooltip`, 'testId')}
  >
    <div
      className={twMerge(
        'flex gap-3 items-center font-bold',
        textColorClasses[status] || 'text-slate-600',
      )}
      {...getTestProps(testId, 'topbar-status')}
    >
      {label}
      <span
        className={twMerge(
          'rounded-full w-3 h-3 lg:w-[18px] lg:h-[18px]',
          dotColorClasses[status] || 'bg-slate-200',
        )}
      />
    </div>
  </Tooltip>
);

export default TopbarStatus;
